import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import AppLayout from '../../component/appLayout';
import { changePasswordDetail } from '../../services/authServices';
import {
  Group,
  Details,
  Form,
  FormBlock,
  InputValue,
  Label,
  PersonalText,
  PersonalHeader,
  MainForm,
  Header
} from './styles';
import ButtonV2 from '../../component/button/buttonV2';
import { isEmpty } from '../../helpers/common';
import { captureException } from '../../services/logService';
import ResponsiveHeader from '../../component/responsiveHeader/header';
import { useMobileDevice } from '../../global/useMobile';
import { rootStore } from '../../mobx/rootStore';
import BottomSubNavigation from '../../component/bottomNavigation/subNavigation';
import { useDispatch } from 'react-redux';
import { BUTTON_TYPE } from '../../global/constants';

const Password: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);

  // MobX store
  const { settingStore } = rootStore;
  const { passwordDetail } = settingStore;
  const { oldPassword, newPassword, confirmPassword } = passwordDetail;

  // Other variables
  const isMobile = useMobileDevice();
  const dispatch = useDispatch();

  // Updates password input fields in the state
  const onChangePassword = useCallback(
    (propsName: string, value: string) => {
      settingStore.updatePasswordDetail(propsName, value);
    },
    [settingStore]
  );

  // Handles form submission and changes password
  const onSubmit = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        console.log('helelelelel');
        if (isEmpty(oldPassword)) {
          rootStore.alertNotificationStore.setErrorMessage('Please enter current password.');
          return;
        } else if (isEmpty(newPassword)) {
          rootStore.alertNotificationStore.setErrorMessage('Please enter new password.');
          return;
        } else if (isEmpty(confirmPassword)) {
          rootStore.alertNotificationStore.setErrorMessage('Please enter confirm password.');
          return;
        } else if (newPassword !== confirmPassword) {
          rootStore.alertNotificationStore.setErrorMessage('Please enter new password and confirm password correctly.');
          return;
        }
        const payload = {
          oldPassword: oldPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword
        };
        const result = await dispatch(changePasswordDetail(payload));
        if (result) {
          settingStore.clearPasswordDetail();
        }
      } catch (error) {
        captureException(error);
        console.log('error', error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
    [oldPassword, newPassword, confirmPassword, dispatch, settingStore]
  );

  return (
    <>
      <AppLayout>
        <Group onSubmit={onSubmit} isMiddleContainer={true}>
          {!isMobile ? (
            <PersonalHeader>
              <Header>
                <PersonalText>Change Password</PersonalText>
              </Header>
            </PersonalHeader>
          ) : (
            <ResponsiveHeader Title='Change Password' />
          )}
          <Details>
            <MainForm>
              <FormBlock isNewRow={true}>
                <Form>
                  <Label>Current Password</Label>
                  <InputValue
                    type='password'
                    value={oldPassword}
                    onChange={(e) => {
                      onChangePassword('oldPassword', e.target.value);
                    }}
                  />
                </Form>
                <Form>
                  <Label>New Password</Label>
                  <InputValue
                    type='password'
                    value={newPassword}
                    onChange={(e) => {
                      onChangePassword('newPassword', e.target.value);
                    }}
                  />
                </Form>
                <Form>
                  <Label>Confirm Password</Label>
                  <InputValue
                    type='password'
                    value={confirmPassword}
                    onChange={(e) => {
                      onChangePassword('confirmPassword', e.target.value);
                    }}
                  />
                </Form>
              </FormBlock>
              <ButtonV2
                title='Save'
                variant={BUTTON_TYPE.PRIMARY}
                buttonType='submit'
                isLoading={loading}
                disabled={loading}
              />
            </MainForm>
          </Details>
        </Group>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};

export default observer(Password);
